// extracted by mini-css-extract-plugin
export var charityItem = "styles-module--charity-item--33tjQ";
export var charityImage = "styles-module--charity-image--3McKA";
export var charitiesCarouselShadow = "styles-module--charities-carousel-shadow--38BZs";